import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        name: 'home',
        path: '',
        component: () => import('pages/IndexPage.vue'),
      },
      {
        name: 'projects',
        path: 'projects',
        component: () => import('pages/ProjectsPage.vue'),
      },
      {
        name: 'project',
        path: 'project/:name',
        component: () => import('pages/ProjectPage.vue'),
      },

      // {
      //   name: 'services',
      //   path: 'services',
      //   component: () => import('pages/ServicesPage.vue'),
      // },

      {
        name: 'blog',
        path: 'blog',
        component: () => import('pages/BlogPage.vue'),
      },

      {
        path: 'blog/:id',
        component: () => import('pages/ArticlePage.vue'),
      },

      // {
      //   name: 'contacts',
      //   path: 'contacts',
      //   // component: () => import('pages/ContactsPage.vue'),
      //   component: () => import('pages/IndexPage.vue'),
      // },

      {
        name: 'speedTest',
        path: 'speed',
        component: () => import('pages/SpeedTestPage.vue'),
      },

      // { path: 'noise', component: () => import('pages/NoisePage.vue') },
      //   { path: 'a', component: () => import('pages/APage.vue') },
      //   { path: 'hs0', component: () => import('pages/examples/HS0Page.vue') },
      //   { path: 'hs1', component: () => import('pages/examples/HS1Page.vue') },
      //   { path: 'hs2', component: () => import('pages/examples/HS2Page.vue') },
      //   { path: 'hsc', component: () => import('pages/examples/HSCPage.vue') },
    ],
  },

  {
    path: '/ex',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: 'animated-line-art',
        component: () =>
          import('pages/ex/animated-line-art/AnimatedLineArtPage.vue'),
      },

      {
        path: 'water-like-distortion',
        component: () =>
          import('pages/ex/water-like-distortion/WaterLikeDistortionPage.vue'),
      },

      {
        path: 'ripple-post-effect',
        component: () =>
          import('pages/ex/ripple-post-effect/RipplePostEffectPage.vue'),
      },

      {
        path: 'water-like-distortion-effect',
        component: () =>
          import(
            'pages/ex/water-like-distortion-effect/WaterLikeDistortionEffectPage.vue'
          ),
      },

      {
        path: 'warp-stars',
        component: () => import('pages/ex/warp-stars/WarpStarsPage.vue'),
      },
    ],
  },

  // Admin
  {
    path: '/admin',
    component: () => import('layouts/AdminLayout.vue'),
    children: [
      {
        name: 'dash',
        path: '',
        component: () => import('pages/admin/AdminPage.vue'),
      },

      {
        name: 'admArticles',
        path: 'articles',
        component: () => import('pages/admin/ArticlesPage.vue'),
      },

      {
        path: 'article/add',
        component: () => import('pages/admin/ArticleAddPage.vue'),
      },
      {
        path: 'article/edit/:id',
        component: () => import('pages/admin/ArticleEditPage.vue'),
      },

      // {
      //   path: 'uploads',
      //   component: () => import('pages/admin/UploadsPage.vue'),
      // },

      {
        path: 'settings',
        component: () => import('pages/admin/SettingsPage.vue'),
      },
    ],
  },

  { path: '/auth', component: () => import('pages/AuthPage.vue') },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
